var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObdPatchBeta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n      }\n\n      .cls-2 {\n        fill: currentColor;\n      }\n\n      .cls-3 {\n        fill: currentColor;\n      }\n\n      .cls-4 {\n        fill: currentColor;\n      }\n\n      .cls-5 {\n        fill: currentColor;\n      }\n\n      .cls-6 {\n        fill: currentColor;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.65,116.5c-2.49,0-4.5-2.01-4.5-4.5v-15.23c0-2.49,2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5v15.23c0,2.49-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.82,116.5c-2.49,0-4.5-2.01-4.5-4.5v-15.23c0-2.49,2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5v15.23c0,2.49-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.82,229.71c-2.49,0-4.5-2.01-4.5-4.5v-15.23c0-2.49,2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5v15.23c0,2.49-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.99,229.71c-2.49,0-4.5-2.01-4.5-4.5v-15.23c0-2.49,2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5v15.23c0,2.49-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.15,229.71c-2.49,0-4.5-2.01-4.5-4.5v-15.23c0-2.49,2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5v15.23c0,2.49-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.63,194.24h-15.23c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5h15.23c2.49,0,4.5,2.01,4.5,4.5s-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.63,175.07h-15.23c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5h15.23c2.49,0,4.5,2.01,4.5,4.5s-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.41,136.74h-15.23c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5h15.23c2.49,0,4.5,2.01,4.5,4.5s-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.41,155.91h-15.23c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5h15.23c2.49,0,4.5,2.01,4.5,4.5s-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.78,214.48h-64.13c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5h64.13c5.03,0,9.11-4.09,9.11-9.11v-70.76c0-5.03-4.09-9.11-9.11-9.11h-70.76c-5.03,0-9.11,4.09-9.11,9.11v35.38c0,2.49-2.01,4.5-4.5,4.5s-4.5-2.01-4.5-4.5v-35.38c0-9.99,8.13-18.11,18.11-18.11h70.76c9.99,0,18.11,8.13,18.11,18.11v70.76c0,9.99-8.13,18.11-18.11,18.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.76,217.3h-45.34c-5.72,0-10.83-3.63-12.71-9.03l-6.36-18.21c-1.44-4.11-.79-8.69,1.73-12.24,2.52-3.55,6.63-5.67,10.98-5.67h58.05c4.35,0,8.46,2.12,10.98,5.67,2.52,3.55,3.17,8.13,1.73,12.24l-6.36,18.21c-1.89,5.4-7,9.03-12.71,9.03ZM54.07,179.15c-2.12,0-4.05.99-5.27,2.72-1.23,1.73-1.53,3.87-.83,5.88l6.36,18.21c.91,2.59,3.36,4.34,6.11,4.34h45.34c2.75,0,5.2-1.74,6.11-4.34l6.36-18.21c.7-2,.4-4.15-.83-5.88-1.23-1.73-3.15-2.72-5.27-2.72h-58.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.49,198.23h-38.81c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5h38.81c1.93,0,3.5,1.57,3.5,3.5s-1.57,3.5-3.5,3.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.04,131.59c-2.49,0-4.5-2.01-4.5-4.5v-48.41c0-8.78-8-15.92-17.82-15.92s-17.82,7.14-17.82,15.92c0,2.49-2.01,4.5-4.5,4.5s-4.5-2.01-4.5-4.5c0-13.74,12.03-24.92,26.82-24.92s26.82,11.18,26.82,24.92v48.41c0,2.49-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.99,
    y: 95.15,
    width: 75.38,
    height: 62.6,
    rx: 12.1,
    ry: 12.1
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Beta"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 61.22,
    y: 205.77,
    width: 161.02,
    height: 54.12,
    rx: 27.06,
    ry: 27.06
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.49,243.78v-23.58c0-2.19,1.23-3.43,3.43-3.43h12.61c5.8,0,8.77,3.7,8.77,7.77,0,3.84-2.38,6.4-5.25,6.99,3.24.5,5.85,3.66,5.85,7.49,0,4.57-3.06,8.22-8.86,8.22h-13.11c-2.19,0-3.43-1.23-3.43-3.47ZM104.11,229.02c2.19,0,3.56-1.42,3.56-3.38s-1.37-3.34-3.56-3.34h-8.13v6.72h8.13ZM104.34,241.73c2.47,0,3.93-1.42,3.93-3.61,0-1.92-1.37-3.56-3.93-3.56h-8.36v7.17h8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.78,243.78v-23.58c0-2.19,1.23-3.43,3.43-3.43h15.63c1.55,0,2.83,1.23,2.83,2.83,0,1.51-1.28,2.74-2.83,2.74h-12.56v6.62h12.24c1.55,0,2.83,1.23,2.83,2.79s-1.28,2.79-2.83,2.79h-12.24v7.08h12.56c1.55,0,2.83,1.28,2.83,2.79s-1.28,2.83-2.83,2.83h-15.63c-2.19,0-3.43-1.23-3.43-3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M153.45,244.33v-21.84h-6.35c-1.55,0-2.88-1.28-2.88-2.83s1.32-2.88,2.88-2.88h19.23c1.55,0,2.88,1.28,2.88,2.88s-1.32,2.83-2.88,2.83h-6.35v21.84c0,1.74-1.46,3.24-3.24,3.24s-3.29-1.51-3.29-3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.99,244.28c0,1.83-1.51,3.29-3.34,3.29-1.42,0-2.65-.91-3.06-2.19l-1.23-3.56h-13.71l-1.23,3.56c-.41,1.28-1.69,2.19-3.11,2.19-1.83,0-3.29-1.46-3.29-3.29,0-.41.14-.82.23-1.14l8.91-23.03c.82-2.15,2.88-3.66,5.35-3.66s4.52,1.51,5.35,3.66l8.86,23.03c.14.32.27.73.27,1.14ZM186.35,236.2l-4.84-13.8-4.84,13.8h9.69Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObdPatchBeta);
export default __webpack_public_path__ + "static/media/obd-patch-beta.d47fd2a91f2f1d50b4d540cb000b8b93.svg";
export { ForwardRef as ReactComponent };